var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 23,
    viewBox: "0 0 15 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000007339"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.74902 18.3335H11.2486",
    stroke: "#EC187B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5 21.9976H9.99972",
    stroke: "#EC187B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.3619 14.6651C11.5869 13.4675 12.1743 12.5387 13.1243 11.6099C13.7278 11.0667 14.2069 10.4047 14.5301 9.66746C14.8532 8.93025 15.0131 8.1345 14.9992 7.33255C14.9992 5.38784 14.209 3.52278 12.8026 2.14766C11.3961 0.772535 9.4886 0 7.49958 0C5.51057 0 3.60302 0.772535 2.19658 2.14766C0.790133 3.52278 0 5.38784 0 7.33255C0 8.55465 0.287484 10.0578 1.8749 11.6099C2.77991 12.419 3.39731 13.4893 3.6373 14.6651",
    fill: "#EC187B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIcon);
export default __webpack_public_path__ + "static/media/footerIcon.bf4d4638ddacf53405bbe5fab4c137d0.svg";
export { ForwardRef as ReactComponent };